import CONSTANTS from "@/constants/index"
import styles from "@/components/Shared/ErrorBoundary/index.module.scss"

const GenericError = props => {
  const { msg = "" } = props
  return (
    <div className={styles.genericErrorWrapper}>
      <h3>{msg ? msg : CONSTANTS.ERROR_MESSAGE.GENERAL}</h3>
    </div>
  )
}
export default GenericError
